export { default } from "./ReportPageHead";
